// extracted by mini-css-extract-plugin
export var cartIcon = "_ne-0";
export var cartIconContainer = "_ne-1";